/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    // Tables can scroll sideways on small screens: make the region keyboard-scrollable
    // and give it a name (WCAG 2.1.1, 1.4.10).
    wrapper.setAttribute('tabindex', '0');
    wrapper.setAttribute('role', 'region');
    const caption = table.querySelector('caption')?.textContent?.trim();
    wrapper.setAttribute('aria-label', caption || 'Table');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
